import Vue from "vue";

export const userConfig = {
  namespaced: true,
  state: {
    accessToken: null,
    refreshToken: null,
    otpId: null,
    loginTempToken: null,
    userPhoneNumber: null,
    deviceIds: null,
    refValue: null,
    userLocation: { id: "" },
    userLoanPhoneNumber: null,
    userInfo: null,
    roles: [],
    merchantContext: null,
    activeWorkspace: "",
    selectedStoreId: null,
  },
  mutations: {
    setAccessToken(state, payload) {
      state.accessToken = payload;
    },
    setRefreshToken(state, payload) {
      state.refreshToken = payload;
    },
    setOtpId(state, payload) {
      state.otpId = payload;
    },
    setLoginTempToken(state, payload) {
      state.loginTempToken = payload;
    },
    setUserPhoneNumber(state, payload) {
      state.userPhoneNumber = payload;
    },
    setdeviceIds(state, payload) {
      state.deviceIds = payload;
    },
    setRefValue(state, payload) {
      state.refValue = payload;
    },
    setUserLocation(state, payload) {
      state.userLocation = payload;
    },
    setUserLoanPhoneNumber(state, payload) {
      state.userLoanPhoneNumber = payload;
    },
    setUserInfo(state, payload) {
      Vue.set(state, "userInfo", payload);
    },
    checkUserRole(state, payload) {
      const rawRoles =
        (payload && payload.roles) ||
        (payload && payload.extended && payload.extended.roles) ||
        [];
      Vue.set(state, "roles", Array.isArray(rawRoles)
        ? rawRoles.map((role) => role.role_title || role.title || role).filter(Boolean)
        : []);
    },
    setMerchantContext(state, payload) {
      Vue.set(state, "merchantContext", payload);
    },
    setActiveWorkspace(state, payload) {
      Vue.set(state, "activeWorkspace", payload || "");
    },
    setSelectedStoreId(state, payload) {
      Vue.set(state, "selectedStoreId", payload ? Number(payload) : null);
    },
    clearAllConfigs(state) {
      state.accessToken = null;
      state.refreshToken = null;
      state.userPhoneNumber = null;
      state.loginTempToken = null;
      state.otpId = null;
      state.userLoanPhoneNumber = null;
      Vue.set(state, "userInfo", null);
      Vue.set(state, "roles", []);
      Vue.set(state, "merchantContext", null);
      Vue.set(state, "activeWorkspace", "");
      Vue.set(state, "selectedStoreId", null);
    },
    clearLoginToken(state) {
      state.loginTempToken = null;
      state.otpId = null;
    },
  },
};
